var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.636 15.91c.95 0 1.759-.608 2.058-1.456h.851c.804 0 1.455-.65 1.455-1.454V9.702l-2.345-1.564-1.167-2.334A1.455 1.455 0 0 0 13.187 5H3.455C2.65 5 2 5.651 2 6.455V13c0 .803.651 1.454 1.455 1.454h.851a2.183 2.183 0 0 0 4.115 0h3.158a2.183 2.183 0 0 0 2.057 1.455Zm.89-6.776-1.34-2.68H3.456V13h.851a2.183 2.183 0 0 1 4.115 0h3.158a2.183 2.183 0 0 1 4.115 0h.851v-2.52l-2.018-1.346Zm-8.162 5.32a.727.727 0 1 0 0-1.454.727.727 0 0 0 0 1.454Zm7.272 0a.727.727 0 1 0 0-1.454.727.727 0 0 0 0 1.454Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.801a17ab.svg";
export { ForwardRef as ReactComponent };